import { getUserInfo } from "../../../api/axios";
import { WebStorage, WebStorageNames } from "../../../utils";
import { ATTENDANCE_ACTION_TYPES } from "./attendanceActionTypes";
import { fetchTodayActivity } from "./attendanceApi";
import { emptyTodayActivity } from "./attendanceReducer";

export const setTodayActivity = (today) => ({
  type: ATTENDANCE_ACTION_TYPES.SET_TODAY_ACTIVITY,
  payload: today ?? emptyTodayActivity(),
});

/**
 * Reloads today's attendance into Redux. Silent refreshes skip the loading spinner
 * so SignalR updates do not flash the hub.
 * @param {{ silent?: boolean }} [options]
 */
export const loadTodayActivity = ({ silent = false } = {}) => {
  return async (dispatch, getState) => {
    if (!silent) {
      const hasToday = getState().attendanceReducer?.today != null;
      if (!hasToday) {
        dispatch({ type: ATTENDANCE_ACTION_TYPES.LOAD_TODAY_REQUEST });
      }
    }
    try {
      const data = await fetchTodayActivity();
      dispatch({
        type: ATTENDANCE_ACTION_TYPES.LOAD_TODAY_SUCCESS,
        payload: data,
      });
      return data;
    } catch (error) {
      dispatch({
        type: ATTENDANCE_ACTION_TYPES.LOAD_TODAY_FAILURE,
        payload: error?.message ?? "Failed to load today's attendance",
      });
      throw error;
    }
  };
};

const normalizeUserId = (id) => {
  if (id == null || id === "") return "";
  return String(id).trim();
};

const currentAttendanceUserId = () => {
  const auth = WebStorage.getLocalStore(WebStorageNames.AuthInfo);
  const user = getUserInfo();
  return normalizeUserId(
    auth?.selfUserId ?? user?.selfUserId ?? user?.id ?? user?.Id
  );
};

let realtimeRefreshTimer = null;

/**
 * SignalR handler: if the punch belongs to the logged-in user, refresh today's
 * attendance in the store (debounced for burst ingest).
 * @param {Record<string, unknown>} payload
 */
export const handleAttendanceRealtimeEvent = (payload) => {
  return (dispatch) => {
    if (!payload || typeof payload !== "object") return;
    const employeeUserId = normalizeUserId(
      payload.employeeUserId ?? payload.EmployeeUserId
    );
    const me = currentAttendanceUserId();
    if (!employeeUserId || !me || employeeUserId !== me) return;

    if (realtimeRefreshTimer) {
      window.clearTimeout(realtimeRefreshTimer);
    }
    realtimeRefreshTimer = window.setTimeout(() => {
      realtimeRefreshTimer = null;
      dispatch(loadTodayActivity({ silent: true })).catch(() => {
        // Hub stays on last known store data; next visibility/manual load retries.
      });
    }, 250);
  };
};
